import React from "react";
import Router from "./router/Router";


const App = () => <Router />

export default App